import { transferCanvasesToClone } from '@terminal/views/insight-feed/utils/prepareDrawerContent';
import { prepareChartFonts } from './copyAlfredCharts';
import { renderChartNodeToHtml } from './copyChartDom';

const SNAPSHOT_BOTTOM_PADDING_PX = 16;

export const renderChartV2Node = async (
  chartNode: HTMLDivElement
): Promise<string> => {
  const fontCss = await prepareChartFonts();

  return renderChartNodeToHtml(chartNode, {
    width: chartNode.offsetWidth,
    height: chartNode.offsetHeight + SNAPSHOT_BOTTOM_PADDING_PX,
    fontCss,
    prepareClone: (clone, source) => {
      clone.style.boxSizing = 'content-box';
      clone.style.height = `${source.offsetHeight}px`;
      clone.style.overflow = 'visible';
      clone.style.paddingBottom = `${SNAPSHOT_BOTTOM_PADDING_PX}px`;

      transferCanvasesToClone(source, clone);
    },
  });
};
